import React, { Component } from "react";
import axios from "axios";
import Serverurl from "./Apiurl";
import {
  Button,
  TextField,
  Typography,
  Stack,
  IconButton,
  Collapse,
  Alert,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Navigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";



// Default placeholder image path
const NO_IMAGE = Serverurl + "uploads/buiness.png";



const CustomTextField = (props) => (
  <TextField
    {...props}
    fullWidth
    variant="outlined"
    sx={{
      "& .MuiOutlinedInput-root": {
      
        borderRadius: "12px",
        "& fieldset": {
          borderColor: "#b9bfc3",
          borderWidth: "1.5px",
        },
        "&:hover fieldset": {
          borderColor: "#9ca3af",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#1e40af",
        },
      },
      "& .MuiInputBase-input": {
        padding: "12px 16px !important",
        fontSize: "14px",
        color: "#333",
      },
      ...props.sx,
    }}
  />
);

export default class BusinessForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bu_logoFile: null,
      bu_authorizedsignatureFile: null,
      bu_id: 0,
      bu_logo: "",
      bu_authorizedsignature: "",
      bu_businessname: "",
      bu_phoneno: "",
      bu_emailid: "",
      bu_address: "",
      bu_gst: "",
      bu_state: "",
      bu_accountnumber: "",
      bu_accountname: "",
      bu_UPIid: "",
      bu_otherinfo: "",
      loading: false,
      emailError: "",
      alertOpen: false,
      alertMessage: "",
      alertSeverity: "success",
      bankDetailsOpen: false
    };
  }

  componentDidMount() {
    if (localStorage.getItem("GBuserid") == null) {
      this.setState({
        logredirect: true,
        pagename: "/Businesslogin"
      });
    }

    const signupData = window.history.state?.usr;
    if (signupData) {
      this.setState({
        bu_businessname: signupData.bu_businessname || "",
        bu_emailid: signupData.bu_emailid || "",
        bu_phoneno: signupData.bu_phoneno || ""
      });
    }
    this.apicall();
  }

  apicall() {
    const bu_id = localStorage.getItem("GBuserid");
    if (!bu_id) return;

    axios.get(Serverurl + "ajaxbusiness.php?action=getall&bu_id=" + bu_id).then((res) => {
      if (res.data && res.data.length > 0) {
        const myBusiness = res.data[0];
        this.setState({
          bu_id: myBusiness.bu_id || 0,
          bu_logo: myBusiness.bu_logo ? Serverurl + "uploads/" + myBusiness.bu_logo : "",
          bu_authorizedsignature: myBusiness.bu_authorizedsignature
            ? Serverurl + "uploads/" + myBusiness.bu_authorizedsignature
            : "",
          bu_businessname: myBusiness.bu_businessname || "",
          bu_phoneno: myBusiness.bu_phoneno || "",
          bu_emailid: myBusiness.bu_emailid || "",
          bu_address: myBusiness.bu_address || "",
          bu_gst: myBusiness.bu_gst || "",
          bu_otherinfo: myBusiness.bu_otherinfo || "",
          bu_state: myBusiness.bu_state || "",
          bu_accountnumber: myBusiness.bu_accountnumber || "",
          bu_accountname: myBusiness.bu_accountname || "",
          bu_UPIid: myBusiness.bu_UPIid || ""
        });
      }
    });
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "bu_phoneno") {
      this.setState({ [name]: value.replace(/\D/g, ""), emailError: "" });
    } else if (name === "bu_gst") {
      this.setState({ bu_gst: value.toUpperCase() });
    } else {
      this.setState({ [name]: value, emailError: "" });
    }
  };

  // Select Logo and preview instantly
  handleLogoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      this.setState({
        bu_logoFile: file,
        bu_logo: URL.createObjectURL(file)
      });
    }
  };

  // Select Signature and preview instantly
  handleSignatureChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      this.setState({
        bu_authorizedsignatureFile: file,
        bu_authorizedsignature: URL.createObjectURL(file)
      });
    }
  };

  handleSave = () => {
    let firstError = "";
    const remail = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/;
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    if (!this.state.bu_logo && !this.state.bu_logoFile) firstError = "Logo is Required";
    else if (!this.state.bu_businessname.trim()) firstError = "Business Name is Required";
    else if (!this.state.bu_phoneno) firstError = "Phone number is required.";
    else if (!/^\d{10}$/.test(this.state.bu_phoneno)) firstError = "Please Enter 10 Digits Phone Number.";
    else if (!this.state.bu_emailid) firstError = "Please Enter Emailid.";
    else if (!remail.test(this.state.bu_emailid)) firstError = "Please Enter Valid Emailid.";
    else if (!this.state.bu_authorizedsignature && !this.state.bu_authorizedsignatureFile)
      firstError = "Authorized signature is Required";
    else if (!this.state.bu_address.trim()) firstError = "Please Enter Address";
    else if (!this.state.bu_gst) firstError = "Please Enter GSTIN Number.";
    else if (!gstRegex.test(this.state.bu_gst)) firstError = "Please Enter a Valid GSTIN.";
    else if (!this.state.bu_state.trim()) firstError = "Please Select State";
    else if (!this.state.bu_accountnumber.trim()) firstError = "Please Enter Account Number";
    else if (!this.state.bu_accountname.trim()) firstError = "Please Enter Account Name";
    else if (!this.state.bu_UPIid.trim()) firstError = "Please Enter UPI ID";

    if (firstError) {
      this.setState({ alertOpen: true, alertMessage: firstError, alertSeverity: "error" });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    this.setState({ alertOpen: false, loading: true });

    const formData = new FormData();
    formData.append("action", "insertorupdate");
    formData.append("bu_id", this.state.bu_id);

    // 1. Logo Handling (Sends "1" + Filedata if file uploaded, else existing filename)
    if (this.state.bu_logoFile) {
      formData.append("bu_logo", "1");
      formData.append("Filedata", this.state.bu_logoFile);
    } else {
      formData.append("bu_logo", this.state.bu_logo.replace(Serverurl + "uploads/", ""));
    }

    // 2. Signature Handling (Sends "1" + Filesignaturedata if file uploaded, else existing filename)
    if (this.state.bu_authorizedsignatureFile) {
      formData.append("bu_authorizedsignature", "1");
      formData.append("Filesignaturedata", this.state.bu_authorizedsignatureFile);
    } else {
      formData.append(
        "bu_authorizedsignature",
        this.state.bu_authorizedsignature.replace(Serverurl + "uploads/", "")
      );
    }

    formData.append("bu_businessname", this.state.bu_businessname);
    formData.append("bu_phoneno", this.state.bu_phoneno);
    formData.append("bu_emailid", this.state.bu_emailid);
    formData.append("bu_address", this.state.bu_address);
    formData.append("bu_gst", this.state.bu_gst);
    formData.append("bu_state", this.state.bu_state);
    formData.append("bu_accountnumber", this.state.bu_accountnumber);
    formData.append("bu_accountname", this.state.bu_accountname);
    formData.append("bu_UPIid", this.state.bu_UPIid);
    formData.append("userid", localStorage.getItem("GBuserid"));
    formData.append("bu_otherinfo", this.state.bu_otherinfo);

    axios.post(Serverurl + "ajaxbusiness.php", formData).then((res) => {
      this.setState({
        alertOpen: true,
        alertMessage: "Business saved successfully",
        alertSeverity: "success",
        loading: false,
        bu_logoFile: null,
        bu_authorizedsignatureFile: null
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      this.apicall(); // Refresh updated image paths
    });
  };

  goBack = () => {
    window.history.back();
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />;
    }

    const states = [
      "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat",
      "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh",
      "Maharashtra", "Manipur", "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab",
      "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal"
    ];

    return (
      <div className="formdisplay">
       	<div className="boxheading">
  <div className="heading-with-back">
        <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>
    <h2>Business Info</h2>
  </div>
</div>

        <Collapse in={this.state.alertOpen}>
          <Alert
            severity={this.state.alertSeverity}
            action={
              <IconButton
                aria-label="close"
                color="inherit"
                size="small"
                onClick={() => this.setState({ alertOpen: false, alertMessage: "" })}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            }
            sx={{ mb: 2 }}
          >
            {this.state.alertMessage}
          </Alert>
        </Collapse>

        <div style={{ display: "flex", gap: "20px", marginBottom: "20px", marginTop: "15px" }}>
          {/* Logo Container */}
          <div style={{ position: "relative", width: "120px", height: "120px", border: "1px dashed #ccc" }}>
            <img
              src={this.state.bu_logo || NO_IMAGE}
              onError={(e) => {
                e.target.src = NO_IMAGE; // Fallback if image fails to load
              }}
              alt="Logo"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
            <IconButton size="small" style={{ position: "absolute", top: 0, right: 0 }} component="label">
              <EditIcon className="editbtn" />
              <input hidden type="file" accept="image/*" onChange={this.handleLogoChange} />
            </IconButton>
          </div>

          {/* Signature Container */}
          <div style={{ position: "relative", width: "120px", height: "120px", border: "1px dashed #ccc" }}>
            <img
              src={this.state.bu_authorizedsignature || NO_IMAGE}
              onError={(e) => {
                e.target.src = NO_IMAGE; // Fallback if image fails to load
              }}
              alt="Signature"
              style={{ width: "100%", height: "100%", objectFit: "contain" }}
            />
            <IconButton size="small" style={{ position: "absolute", top: 0, right: 0 }} component="label">
              <EditIcon className="editbtn" />
              <input hidden type="file" accept="image/*" onChange={this.handleSignatureChange} />
            </IconButton>
          </div>
        </div>

      <Stack spacing={2.5}>
  {/* Business Name */}
  <CustomTextField
  label="Business Name"
    placeholder="Business Name"
    name="bu_businessname"
    inputProps={{ maxLength: 150 }}
    value={this.state.bu_businessname}
    onChange={this.handleChange}
    required
  />

  {/* Phone Field with Flag */}
  <Box style={{ display: "flex", gap: "10px" }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "6px",
        backgroundColor: "#f8f9fa",
        border: "1.5px solid #d1d5db",
        borderRadius: "12px",
        padding: "0 12px",
        minWidth: "85px",
      }}
    >
      <img
        src="https://flagcdn.com/w20/in.png"
        alt="India"
        style={{ width: "20px", height: "14px", borderRadius: "2px" }}
      />
      <Typography variant="body2" style={{ fontWeight: 600, color: "#333" }}>
        +91
      </Typography>
    </Box>
    <CustomTextField
	label="Phone Number"
      placeholder="Phone Number *"
      name="bu_phoneno"
      inputProps={{ maxLength: 10 }}
      value={this.state.bu_phoneno}
      onChange={this.handleChange}
      required
    />
  </Box>

  {/* Email */}
  <CustomTextField
  label="Email"
    placeholder="Email *"
    type="email"
    name="bu_emailid"
    inputProps={{ maxLength: 150 }}
    value={this.state.bu_emailid}
    onChange={this.handleChange}
    error={Boolean(this.state.emailError)}
    helperText={this.state.emailError}
  />

  {/* Address */}
  <CustomTextField
  label="Address"
    placeholder="Address *"
    name="bu_address"
    inputProps={{ maxLength: 150 }}
    value={this.state.bu_address}
    onChange={this.handleChange}
	InputLabelProps={{ shrink: true }}
    multiline
    rows={3}
  />

  {/* GSTIN */}
  <CustomTextField
  label="GSTIN Number"
    placeholder="GSTIN Number *"
    name="bu_gst"
    inputProps={{ maxLength: 15 }}
    value={this.state.bu_gst}
    onChange={this.handleChange}
	InputLabelProps={{ shrink: true }}
  />

  {/* State Dropdown */}
  <CustomTextField
    select
	label="Select State"
    name="bu_state"
    value={this.state.bu_state}
    onChange={this.handleChange}
    SelectProps={{ native: true }}
	InputLabelProps={{ shrink: true }}
  >
    <option value="">Select State *</option>
    {states.map((state) => (
      <option key={state} value={state}>
        {state}
      </option>
    ))}
  </CustomTextField>

  {/* Other Info */}
  <CustomTextField
  label="Other Info"
    placeholder="Other Info *"
    name="bu_otherinfo"
    inputProps={{ maxLength: 150 }}
    value={this.state.bu_otherinfo}
    onChange={this.handleChange}
	InputLabelProps={{ shrink: true }}
  />

  {/* Bank Details Accordion */}
  <Accordion
    expanded={this.state.bankDetailsOpen}
    onChange={() => this.setState({ bankDetailsOpen: !this.state.bankDetailsOpen })}
	InputLabelProps={{ shrink: true }}
	
    sx={{
      boxShadow: "none",
      border: "1.5px solid #d1d5db",
      borderRadius: "12px !important",
      backgroundColor: "#f8f9fa",
      "&:before": { display: "none" },
    }}
  >
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
      <Typography style={{ fontWeight: 600 }}>Bank Details</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ display: "flex", flexDirection: "column", gap: 2, backgroundColor: "#f0f4f7" }}>
      <CustomTextField
	  label="Account Number"
        placeholder="Account Number *"
        name="bu_accountnumber"
        inputProps={{ maxLength: 15 }}
        value={this.state.bu_accountnumber}
        onChange={this.handleChange}
		InputLabelProps={{ shrink: true }}
      />
      <CustomTextField
	  label="Account Name"
        placeholder="Account Name *"
        name="bu_accountname"
        inputProps={{ maxLength: 150 }}
        value={this.state.bu_accountname}
        onChange={this.handleChange}
		InputLabelProps={{ shrink: true }}
      />
      <CustomTextField
	  label="UPI ID"
        placeholder="UPI ID *"
        name="bu_UPIid"
        inputProps={{ maxLength: 150 }}
        value={this.state.bu_UPIid}
        onChange={this.handleChange}
			InputLabelProps={{ shrink: true }}
      />
    </AccordionDetails>
  </Accordion>

  <p className="aligncentr">
    <Button
      variant="contained"
      className="primartybtn"
	  style={{ borderRadius: "20px",
    minWidth: "110px", }}
      onClick={this.handleSave}
      disabled={this.state.loading}
    >
      {this.state.loading ? "Saving..." : "Save"}
    </Button>
  </p>
</Stack>
      </div>
    );
  }
}